import _ from "underscore";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { ModalHeader, ModalFooterWithButtons, VerticalTabPanel } from "@evertrue/et-components";
import CDCPanelController from "./cdc-panel-controller";
import { CDCNoteManager } from "../contexts/cdc-provider";
import Decorator from "@evertrue/client-decorator";
import { WithCDCDependencies } from "../contexts/cdc-dependencies-context";
import classNames from "classnames";

const ADDRESS_WHITELIST = ["type", "address_1", "address_2", "address_3", "city", "state", "zip_code", "country"];

const getFilteredAddress = address => {
  return _.mapObject(_.pick(address, ADDRESS_WHITELIST), address_property => {
    return address_property.value;
  });
};

const renderLabel = (field = {}, label) => {
  const primary = field.primary && field.primary.value ? "(Primary)" : "";
  return `${(field.type && field.type.value) || label} ${primary}`;
};

const getPlaceholder = type => {
  if (type === "phone") return "xxx-xxx-xxxx x123";
  if (type === "email") return "name@email.com";
};

const truncate = (text = "", limit) => {
  if (text.length > limit) {
    return text.substring(0, limit - 3) + "...";
  }
  return text;
};

const NAVITEMS = (contact, onSuccess, onFailure) => [
  {
    label: "Phone",
    key: 1,
    icon: "call",
    iconSize: 1,
    render: () => (
      <CDCPanelController
        contact={contact}
        contactData={contact.phones}
        dataKey="phone"
        icon="call"
        renderLabel={field => renderLabel(field, "phone")}
        generateUID={field => field.phone && field.phone.value + field.phone.timestamp}
        getValue={(field = {}) => field.phone && field.phone.value}
        getPlaceholder={getPlaceholder}
        onSuccess={onSuccess}
        onFailure={onFailure}
      />
    ),
  },
  {
    label: "Email",
    key: 2,
    icon: "email",
    iconSize: 1,
    render: () => (
      <CDCPanelController
        contact={contact}
        contactData={contact.emails}
        dataKey="email"
        icon="email"
        renderLabel={field => renderLabel(field, "email")}
        generateUID={field => field.email && field.email.value + field.email.timestamp}
        getValue={field => field.email && field.email.value}
        getPlaceholder={getPlaceholder}
        onSuccess={onSuccess}
        onFailure={onFailure}
      />
    ),
  },
  {
    label: "Address",
    key: 3,
    icon: "map-marker-bts",
    iconSize: 1,
    render: () => (
      <CDCPanelController
        contact={contact}
        contactData={contact.addresses}
        dataKey="address"
        icon="map-marker-bts"
        renderLabel={field => renderLabel(field, "address")}
        generateUID={field => field.lat && String(field.lat.value + field.lat.created_at)}
        getValue={getFilteredAddress}
        onSuccess={onSuccess}
        onFailure={onFailure}
      />
    ),
  },
  {
    label: "Misc",
    key: 4,
    icon: "misc",
    iconSize: 1,
    render: () => (
      <CDCPanelController
        contact={contact}
        dataKey="misc"
        icon="misc"
        renderLabel={field => renderLabel(field, "misc")}
        onSuccess={onSuccess}
        onFailure={onFailure}
      />
    ),
  },
];

class CDCModalController extends Component {
  static propTypes = {
    contact: PropTypes.object,
    referrer: PropTypes.string,
    onClose: PropTypes.func,
    dependencies: PropTypes.object.isRequired,
  };

  static defaultProps = {
    referrer: "",
    onClose: _.noop,
    dependencies: {},
  };

  state = {
    currentTab: 1,
    numberOfSuggestions: 0,
  };

  componentDidMount() {
    this.props.dependencies.setMixPanelReferrer(this.props.referrer);
    this.props.dependencies.sendMixPanel("contact_suggestion", { type: "view" });
  }

  onTabChange = selectedTab => {
    this.setState({ currentTab: selectedTab });
    document.getElementsByClassName("et-vertical-tab-panel--content")[0].scrollTop = 0;
  };

  onSuccess = () => {
    this.props.dependencies.successToast("Suggestion Sent.");
    this.setState({ numberOfSuggestions: this.state.numberOfSuggestions + 1 });
    document.getElementsByClassName("et-vertical-tab-panel--content")[0].scrollTop = 0;
  };

  onFailure = () => {
    document.getElementsByClassName("et-vertical-tab-panel--content")[0].scrollTop = 0;
  };

  renderHeader = () => {
    let name = Decorator.Contacts.getDetailedName(this.props.contact);

    name = truncate(name, 50);

    return <h3>{name ? `${name} - Contact Update` : "Contact Update"}</h3>;
  };

  renderSuggestionCount = () => {
    const { numberOfSuggestions } = this.state;
    if (numberOfSuggestions > 0) return `${numberOfSuggestions} suggestion${numberOfSuggestions > 1 ? "s" : ""} sent`;
  };

  render() {
    const navItems = NAVITEMS(this.props.contact, this.onSuccess, this.onFailure);
    const tabContent = _.findWhere(navItems, { key: this.state.currentTab });
    return (
      <CDCNoteManager>
        <div className={classNames("cdc-modal", { "is-mobile": this.props.dependencies.isMobile })}>
          <ModalHeader header={this.renderHeader()} closeModal={this.props.onClose} />
          <div className="cdc-controller">
            <VerticalTabPanel
              contact={this.props.contact}
              items={navItems}
              value={tabContent}
              handleTabChange={this.onTabChange}
            />
          </div>
          <ModalFooterWithButtons
            className="cdc-modal--footer"
            rightChildren={this.renderSuggestionCount()}
            onCancel={this.props.onClose}
            cancelLabel="Close"
          />
        </div>
      </CDCNoteManager>
    );
  }
}

export default WithCDCDependencies(CDCModalController);
